function ProgressPill(props: { step: number; totalSteps: number }) {
  return (
    <div className="text-content-primary text-xs font-normal">
      Step {props.step}/{props.totalSteps}
    </div>
  );
}

export default ProgressPill;
